import React, { ReactNode } from 'react';
import { BeaconType } from '../../../models/Beacon';

export const ErrorMessageUploadFromURLView = (url: string, beacon: BeaconType): ReactNode => {
  return (
    <>
      Please{' '}
      <a target={'_blank'} href={url} rel={'noreferrer'}>
        check the URL
      </a>{' '}
      is for a valid image and try again. <a onClick={() => beacon('article', '683', { type: 'modal' })}>Learn more</a>.
    </>
  );
};
